var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      widthClass: "max-1000",
      title: _vm.$t("label_essweb_holiday_form_newTitle"),
      backgroundClass: "white",
      initData: _vm.HolidayData,
      checkData: [
        "holiday_name",
        "holiday_abbr",
        "holiday_utc_date",
        "remarks",
      ],
    },
    on: {
      change: function (changed) {
        return (_vm.isChanged = changed)
      },
    },
    scopedSlots: _vm._u([
      {
        key: "page-main",
        fn: function () {
          return [
            _c(
              "v-form",
              { ref: "form", attrs: { "lazy-validation": "" } },
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c("inputTextFiledMultiLang", {
                          attrs: {
                            bindData: _vm.HolidayData.holiday_name,
                            maxlength: "100",
                            label: _vm.$t(
                              "label_essweb_holiday_form_publicHolidayNameLabel"
                            ),
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                          },
                          on: {
                            change: function (valueArr) {
                              _vm.HolidayData.holiday_name = valueArr
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c("inputTextFiledMultiLang", {
                          attrs: {
                            bindData: _vm.HolidayData.holiday_abbr,
                            maxlength: "100",
                            label: _vm.$t(
                              "label_essweb_holiday_form_publicHolidayAbbrLabel"
                            ),
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                          },
                          on: {
                            change: function (valueArr) {
                              _vm.HolidayData.holiday_abbr = valueArr
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("DateTimePicker", {
                          attrs: {
                            type: "date",
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                            defaultTime: _vm.HolidayData.holiday_utc_date,
                            label: _vm.$t(
                              "label_essweb_holiday_form_publicHolidayDateLabel"
                            ),
                          },
                          on: {
                            change: function (time) {
                              return (_vm.HolidayData.holiday_utc_date = time)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("v-sheet", { staticClass: "text--secondary" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "label_essweb_holiday_form_publicHolidayRemarkLabel"
                              )
                            )
                          ),
                        ]),
                        _c("v-textarea", {
                          attrs: {
                            rows: "5",
                            "no-resize": "",
                            filled: "",
                            dense: "",
                            maxlength: "500",
                            "single-line": "",
                            counter: "500",
                            name: "input-7-4",
                          },
                          model: {
                            value: _vm.HolidayData.remarks,
                            callback: function ($$v) {
                              _vm.$set(_vm.HolidayData, "remarks", $$v)
                            },
                            expression: "HolidayData.remarks",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "page-actions",
        fn: function () {
          return [
            _c("CardActions", {
              attrs: { newBtn: "" },
              on: {
                new: _vm.toNew,
                cancel: function ($event) {
                  return _vm.$toBack(_vm.isChanged)
                },
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }